import styled from "styled-components";

export const UserMenuHolderDefaultBox = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 0 0.5rem 0;
  overflow: hidden;
  
  /*
  .cgp-rtl & {
      padding: 0.5rem 0 0.5rem 0.25rem;
    }
   */
`